import axios from './configAxios';

export const getVehiclesApi = async (url) => {
	return await axios.get(`vehicles/${url ? `?${url}` : ''}`);
};
